import { Button } from "@mui/material";
import { ARR_CATEGORY_OBJ, CATEGORY_DESCRIPTION } from "../utils/constants";
import { CapitalizeWord, List, StyledTitle, WrapperCategory } from "../views/Simulation.styled";
import { Link } from "react-router-dom";

export const SimulationListNotRegister = () => {
    return (
        <>
    {
        ARR_CATEGORY_OBJ.length > 0 && ARR_CATEGORY_OBJ.map(({ category, arrId }) =>
                 (
                        <WrapperCategory color={category} key={category}>
                        <StyledTitle>
                            <CapitalizeWord>{category}: </CapitalizeWord>
                            {CATEGORY_DESCRIPTION[category]}
                        </StyledTitle>
                        <List>
                            {arrId.length>0 && arrId.map(({ year, _id }) =>
                            (<li key={_id}>
                                <Button component={Link} to={`/simulation/${_id}`} color={category} variant="contained" >{year}</Button>
                            </li>))}
                            </List>
                    </WrapperCategory>)
                )}
    </>)
}